import { SaleInvoicesListTableDocument } from 'generated/resources/graphql'
import { DuplicateSaleInvoiceDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'

import handleResultWithFlash from 'modules/finance/lib/handleResultWithFlash'

export const useDuplicateSaleInvoice = () => {
  const [duplicateSaleInvoice, {}] = useMutation(DuplicateSaleInvoiceDocument, {
    extractorFn: (data) => data.financeMutations.duplicateSaleFinanceFinancialDocument,
    refetchQueries: [SaleInvoicesListTableDocument],
  })

  const handleDuplicateSaleInvoice = async ({
    invoiceId,
    currentEmployeeId,
  }: {
    invoiceId: string
    currentEmployeeId: string
  }) => {
    const result = await duplicateSaleInvoice({
      variables: {
        id: invoiceId,
        authorId: currentEmployeeId,
      },
    })

    const handled = handleResult(result, handleResultWithFlash())

    if (handled.success) {
      track(trackingEvents.accounting.saleInvoices.duplicate)
      return handled.data.financialDocument?.id
    }

    return null
  }

  return { handleDuplicateSaleInvoice }
}
